const segmentBasic = {
  getlist: 'segmentbase/getlist',
  update: 'segmentbase/update',
  getall: 'segmentbase/getall',
}
export default segmentBasic
